import React from "react";
import { Input } from "antd";
import { globalVar } from "../../common/utils";

export const SearchComponent = ({ text, placeholder, onChange }) => {
  let timeOutId;
  const onTextChange = (e) => {
    const text = e.target.value;
    clearTimeout(timeOutId);
    timeOutId = setTimeout(() => onChange(text), 600);
  };

  return (
    <Input
      ref={(node) => {
        globalVar.searchInput = node;
      }}
      allowClear={true}
      placeholder={`Search ${placeholder}`}
      defaultValue={text}
      onChange={onTextChange}
      style={{ width: 188 }}
    />
  );
};
